<template>
    <div class="dashboard">
        <h1>納入先{{ contents[contentsType].title }}</h1>
        <ValidationObserver ref="observer" v-slot="{ invalid }" class="l-2-10-t--all" tag="div">
            <div class="l-w2 is-left">
                <h2>納入日</h2>
                <ValidationProvider v-slot="{ errors }" class="l-mt2" name="納入日" rules="required" tag="div" :immediate="$_getValidatedImmediate()">
                    <input v-model="input.delivery_destination_date" type="date">
                    <p class="errorMessage">{{ errors[0] }}</p>
                </ValidationProvider>
                <h2>施工業者</h2>
                <ValidationProvider v-slot="{ errors }" class="l-mt2" name="施工業者" rules="max:50|required" tag="div" :immediate="$_getValidatedImmediate()">
                    <input v-model="input.contractor" type="text">
                    <p class="errorMessage">{{ errors[0] }}</p>
                </ValidationProvider>
                <h2>現場名</h2>
                <ValidationProvider v-slot="{ errors }" class="l-mt2" name="現場名" rules="max:50|required" tag="div" :immediate="$_getValidatedImmediate()">
                    <input v-model="input.delivery_destination_name" type="text">
                    <p class="errorMessage">{{ errors[0] }}</p>
                </ValidationProvider>
                <h2>画像</h2>
                <div class="l-mt2">
                    <InputFile :input-file="inputFile1" @data="input.image_1 = $event" @delete-flag="input.image_1_delete_flag = $event" />
                </div>
                <div class="l-mt8">
                    <InputFile :input-file="inputFile2" @data="input.image_2 = $event" @delete-flag="input.image_2_delete_flag = $event" />
                </div>
                <!-- <div class="l-mt8">
                    <InputFile :input-file="inputFile3" @data="input.image_3 = $event" @delete-flag="input.image_3_delete_flag = $event" />
                </div> -->
                <Loader class="is-center" style="margin-top: 56px;" :loader="loader" />
                <div v-if="!loader" style="margin-top: 56px;">
                    <button v-if="contentsType === 'update'" :class="`${classButtonStyle}cancel`" type="button" @click="$_goBack()">戻る</button>
                    <button v-if="contentsType === 'create'" :class="X_validatedButtonStyle" type="button" :disabled="$_setValidatedDisabled(invalid)" @click="handleCreate()">{{ contents[contentsType].title }}</button>
                    <button v-else-if="contentsType === 'update'" :class="X_validatedButtonStyle" type="button" :disabled="$_setValidatedDisabled(invalid)" @click="handleUpdate()">{{ contents[contentsType].title }}</button>
                </div>
            </div>
            <div class="l-w7 is-left">
                <h2>納入先住所</h2>
                <ValidationProvider v-slot="{ errors }" class="l-mt1" name="納入先住所" rules="max:100|required" tag="div" style="margin-top: .7% !important;" :immediate="$_getValidatedImmediate()">
                    <input v-model="input.delivery_destination_address" type="text" @change="initializeMap()">
                    <p class="errorMessage">{{ errors[0] }}</p>
                </ValidationProvider>
                <div v-show="input.delivery_destination_address_lat && input.delivery_destination_address_lng" ref="googleMap" class="l-mt2" style="height:500px;"></div>
                <h2>大禁時間帯</h2>
                <div>
                    <input id="forbidden_time_flag" v-model="input.forbidden_time_flag" type="checkbox" true-value="1" false-value="0">
                    <label for="forbidden_time_flag">あり</label>
                </div>
            </div>
        </ValidationObserver>
        <Modal :modal="modal" @action="modalAction($event)" @close="$_modalClose()" />
    </div>
</template>

<script>
    "use strict";

    import Loader from "@/components/OfficesLoader.vue";

    import GoogleMapsApiLoader from "google-maps-api-loader";
    import common from "@/mixins/common";
    import inputFile from "@/mixins/inputFile";

    const contents = {
        "create": {
            "flagDisabled": false,
            "title": "登録",
        },
        "update": {
            "flagDisabled": true,
            "title": "変更",
        },
    };

    export default {
        "components": {
            Loader,
        },
        "mixins": [
            common,
            inputFile,
        ],
        "props": {
            "id": {
                "default": "",
                "required": false,
                "type": String,
            },
            "baseId": {
                "default": "",
                "required": false,
                "type": String,
            },
        },
        data() {
            return {
                "contents": contents,
                "contentsType": "create",
                "deliveryDestinationsId": "",
                "loader": false,
                "google": "",
                "googleApiKey": common.$_configs.googleApiKey,
                "googleMapZoom": 14,
                "input": {
                    "delivery_destination_date": "",
                    "contractor": "",
                    "delivery_destination_name": "",
                    "delivery_destination_address": "",
                    "delivery_destination_address_lat": "",
                    "delivery_destination_address_lng": "",
                    "forbidden_time_flag": "",
                    "image_1": "",
                    "image_2": "",
                    "image_3": "",
                },
                "inputFile1": {
                    "accept": ".gif, .jpg, .jpeg, .png, .bmp",
                    "id": "1",
                    "thumbnail": {
                        "path": "",
                    },
                },
                "inputFile2": {
                    "accept": ".gif, .jpg, .jpeg, .png, .bmp",
                    "id": "2",
                    "thumbnail": {
                        "path": "",
                    },
                },
                "inputFile3": {
                    "accept": ".gif, .jpg, .jpeg, .png, .bmp",
                    "id": "3",
                    "thumbnail": {
                        "path": "",
                    },
                },
            };
        },
        "watch": {
            $route() {
                // メニューリストから画面遷移したときの初期化
                if (!this.id) {
                    for (let key in this.input) {
                        this.input[key] = "";
                    }
                    this.contentsType = "create";
                    this.input.delivery_destination_address_lat = "";
                    this.input.delivery_destination_address_lng = "";
                    this.inputFile1.thumbnail.path = "";
                    this.inputFile2.thumbnail.path = "";
                    this.inputFile3.thumbnail.path = "";
                    this.$_setValidatedImmediate();
                }
            },
        },
        created() {
            if (this.id) {
                // 登録画面から編集画面へ切り替え
                this.contentsType = "update";
                this.deliveryDestinationsId = this.id;
                this.fetchingDataDeliveryDestinations();
            } else if (this.baseId) {
                // 登録画面から再登録画面へ切り替え
                this.contentsType = "create";
                this.deliveryDestinationsId = this.baseId;
                this.fetchingDataDeliveryDestinations();
            } else {
                this.$_setValidatedImmediate();
            }
        },
        async mounted() {
            this.google = await GoogleMapsApiLoader({
                "apiKey": this.googleApiKey,
                "libraries": ["places"],
            });
        },
        "methods": {
            initializeMap() {
                const geocoder = new this.google.maps.Geocoder();
                geocoder.geocode({
                    "address": this.input.delivery_destination_address,
                }, (results, status) => {
                    if (status === "OK" && results[0]) {
                        let map = "";
                        let marker = "";
                        const updateMode = true;
                        // if (this.id) {
                        if (updateMode) {
                            // update
                            if (!this.input.delivery_destination_address_lat && !this.input.delivery_destination_address_lng) {
                                this.input.delivery_destination_address_lat = results[0].geometry.location.lat();
                                this.input.delivery_destination_address_lng = results[0].geometry.location.lng();
                            }
                            const latlng = new this.google.maps.LatLng(this.input.delivery_destination_address_lat, this.input.delivery_destination_address_lng);
                            map = new this.google.maps.Map(this.$refs.googleMap, {
                                "center": latlng,
                                "zoom": this.googleMapZoom,
                                "mapTypeControl": false,
                                "fullscreenControl": false,
                                "streetViewControl": false,
                            });
                            marker = new this.google.maps.Marker({
                                "position": latlng,
                                "draggable": true,
                                "map": map,
                            });
                        } else {
                            // create
                            this.input.delivery_destination_address_lat = results[0].geometry.location.lat();
                            this.input.delivery_destination_address_lng = results[0].geometry.location.lng();
                            map = new this.google.maps.Map(this.$refs.googleMap, {
                                "center": results[0].geometry.location,
                                "zoom": this.googleMapZoom,
                                "mapTypeControl": false,
                                "fullscreenControl": false,
                                "streetViewControl": false,
                            });
                            marker = new this.google.maps.Marker({
                                "position": results[0].geometry.location,
                                "draggable": true,
                                "map": map,
                            });
                        }
                        this.google.maps.event.addListener(marker, "dragend", (e) => {
                            this.input.delivery_destination_address_lat = e.latLng.lat();
                            this.input.delivery_destination_address_lng = e.latLng.lng();
                        });
                    }
                }); 
            },
            fetchingDataDeliveryDestinations() {
                // 個別納入先データ取得
                common.$_axios.get(
                    `${common.$_configs.apiUrl}/delivery_destinations/${this.deliveryDestinationsId}`,
                    this.$_requestConfig()
                ).then(response => {
                    this.input = response.data;
                    if (this.baseId) {
                        this.inputFile1.thumbnail.path = "";
                        this.inputFile2.thumbnail.path = "";
                        this.inputFile3.thumbnail.path = "";
                    } else {
                        const path1 = response.data.image_1 ? `${common.$_configs.filesUrl}${response.data.image_1}` : "";
                        const path2 = response.data.image_2 ? `${common.$_configs.filesUrl}${response.data.image_2}` : "";
                        const path3 = response.data.image_3 ? `${common.$_configs.filesUrl}${response.data.image_3}` : "";
                        this.inputFile1.thumbnail.path = path1;
                        this.inputFile2.thumbnail.path = path2;
                        this.inputFile3.thumbnail.path = path3;
                    }
                    this.initializeMap();
                }).catch(() => {
                    this.$_modalError("fetchingDeliveryDestinationsError");
                });
            },
            handleCreate() {
                this.loader = true;
                let nullFile = new File([""], "", { "type": null });
                let formData = new FormData();
                formData.append("image_1", this.input.image_1 ? this.input.image_1 : nullFile);
                formData.append("image_2", this.input.image_2 ? this.input.image_2 : nullFile);
                formData.append("image_3", this.input.image_3 ? this.input.image_3 : nullFile);
                formData.append("data", `{
                    "delivery_destination_date": "${this.input.delivery_destination_date}",
                    "contractor": "${this.input.contractor}",
                    "delivery_destination_name": "${this.input.delivery_destination_name}",
                    "delivery_destination_address": "${this.input.delivery_destination_address}",
                    "delivery_destination_address_lat": "${this.input.delivery_destination_address_lat}",
                    "delivery_destination_address_lng": "${this.input.delivery_destination_address_lng}",
                    "forbidden_time_flag": "${this.input.forbidden_time_flag}",
                }`);
                // 個別納入先データ追加
                common.$_axios.post(
                    `${common.$_configs.apiUrl}/delivery_destinations`,
                    formData,
                    this.$_requestConfig("file")
                ).then(() => {
                    this.$router.push({ "name": "offices_delivery_allocations_create" });
                }).catch(() => {
                    this.$_modalError("createDeliveryDestinationsError");
                    this.loader = false;
                });
            },
            handleUpdate() {
                this.loader = true;
                let nullFile = new File([""], "", { "type": null });
                let formData = new FormData();
                if (!this.input.image_1_delete_flag) {
                    this.input.image_1_delete_flag = "0";
                }
                if (!this.input.image_2_delete_flag) {
                    this.input.image_2_delete_flag = "0";
                }
                if (!this.input.image_3_delete_flag) {
                    this.input.image_3_delete_flag = "0";
                }
                formData.append("image_1", this.input.image_1 ? this.input.image_1 : nullFile);
                formData.append("image_2", this.input.image_2 ? this.input.image_2 : nullFile);
                formData.append("image_3", this.input.image_3 ? this.input.image_3 : nullFile);
                formData.append("data", `{
                    "delivery_destination_date": "${this.input.delivery_destination_date}",
                    "contractor": "${this.input.contractor}",
                    "delivery_destination_name": "${this.input.delivery_destination_name}",
                    "delivery_destination_address": "${this.input.delivery_destination_address}",
                    "delivery_destination_address_lat": "${this.input.delivery_destination_address_lat}",
                    "delivery_destination_address_lng": "${this.input.delivery_destination_address_lng}",
                    "forbidden_time_flag": "${this.input.forbidden_time_flag}",
                    "image_1_delete_flag": "${this.input.image_1_delete_flag}",
                    "image_2_delete_flag": "${this.input.image_2_delete_flag}",
                    "image_3_delete_flag": "${this.input.image_3_delete_flag}",
                }`);
                // 個別納入先データ変更
                common.$_axios.post(
                    `${common.$_configs.apiUrl}/delivery_destinations/${this.id}`,
                    formData,
                    this.$_requestConfig("file")
                ).then(() => {
                    this.$router.push({ "name": "offices_delivery_allocations_create" });
                }).catch(() => {
                    this.$_modalError("updateDeliveryDestinationsError");
                    this.loader = false;
                });
            },
        },
    };
</script>

<style lang="scss" scoped>
    h1 {
        margin-bottom: 0;
    }
    h2 {
        font-size: 20px;
        margin-top: 28px !important;
    }
</style>
